/*
  assets/n90-quote.js
  Kit quote builder — sections/main-quote.liquid.

  - Turns the four steps into a wizard (.is-wizard): stepper buttons, Continue / Back, the
    submit button reads "Continue" until the last step. Without this script every step shows
    and the form submits as normal.
  - Keeps the "Your request" card in sync with the choices ([data-qt-field] → [data-qt-sum]).
  - If Shopify returns errors, the wizard opens on the step with the problem field.
  - After a successful post, the thank-you state is focused and scrolled into view.
*/
(function () {
  if (window.n90Quote) return;
  window.n90Quote = true;

  var DASH = '—';

  function init(root) {
    if (root.dataset.qtReady) return;
    root.dataset.qtReady = 'true';

    function showThanks(el) {
      root.scrollIntoView({ block: 'start' });
      el.focus({ preventScroll: true });
    }

    var thanks = root.querySelector('[data-qt-thanks]:not([data-qt-thanks-fallback])');
    if (thanks) {
      showThanks(thanks);
      return;
    }

    /* Back from the return_to redirect (?contact_posted=true) without Shopify's success flag:
       swap the builder for the thank-you state. Never when the post came back with errors. */
    var fallback = root.querySelector('[data-qt-thanks-fallback]');
    var posted = /(?:^|[?&])(?:contact_)?posted=true(?:&|$)/.test(window.location.search);
    if (fallback && posted && !root.querySelector('[data-qt-alert]')) {
      var builder = root.querySelector('[data-qt-builder]');
      if (builder) builder.hidden = true;
      fallback.hidden = false;
      showThanks(fallback);
      return;
    }

    var form = root.querySelector('form');
    if (!form) return;
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-qt-step]'));
    var stepBtns = Array.prototype.slice.call(root.querySelectorAll('[data-qt-goto]'));
    var stepper = root.querySelector('[data-qt-stepper]');
    var mstep = root.querySelector('[data-qt-mstep]');
    var back = root.querySelector('[data-qt-back]');
    var cont = root.querySelector('[data-qt-continue]');
    var submit = root.querySelector('[data-qt-submit]');
    var submitLabel = root.querySelector('[data-qt-submit-label]');
    var total = steps.length;
    var current = 1;
    var visited = 1;

    /* ── Summary ── */
    function checkedLabels(key) {
      var field = root.querySelector('[data-qt-field="' + key + '"]');
      if (!field) return [];
      return Array.prototype.slice.call(field.querySelectorAll('input:checked')).map(function (i) {
        return i.dataset.label || i.value;
      });
    }
    function checkedHex(key) {
      var field = root.querySelector('[data-qt-field="' + key + '"]');
      var input = field && field.querySelector('input:checked');
      return input ? input.dataset.hex : '';
    }
    function setSum(key, text) {
      var el = root.querySelector('[data-qt-sum="' + key + '"]');
      if (el) el.textContent = text || DASH;
    }
    function formatDate(value) {
      if (!value) return '';
      var d = new Date(value + 'T00:00:00');
      if (isNaN(d.getTime())) return value;
      try {
        return d.toLocaleDateString(document.documentElement.lang || undefined, { day: 'numeric', month: 'short', year: 'numeric' });
      } catch (e) {
        return value;
      }
    }
    function refresh() {
      ['sport', 'items', 'players', 'ages'].forEach(function (key) {
        setSum(key, checkedLabels(key).join(', '));
      });

      var dateInput = root.querySelector('[data-qt-field="date"] input');
      setSum('date', dateInput ? formatDate(dateInput.value) : '');

      var crestInput = root.querySelector('[data-qt-field="crest"] input');
      var crestSum = root.querySelector('[data-qt-sum="crest"]');
      if (crestSum) crestSum.textContent = crestInput && crestInput.value.trim() ? crestSum.dataset.filled : DASH;

      var names = [];
      ['colour_1', 'colour_2'].forEach(function (key) {
        var name = checkedLabels(key)[0] || '';
        var hex = checkedHex(key);
        var chosen = root.querySelector('[data-qt-chosen="' + key + '"]');
        var dot = root.querySelector('[data-qt-dot="' + key + '"]');
        if (chosen) chosen.textContent = name || DASH;
        if (dot) {
          dot.hidden = !hex;
          dot.style.background = hex || '';
        }
        if (name) names.push(name);
      });
      setSum('colours', names.join(' / '));
    }
    form.addEventListener('change', refresh);
    form.addEventListener('input', function (e) {
      if (e.target.matches('[data-qt-field] input')) refresh();
    });
    refresh();

    /* ── Wizard ──
       Steps 1–3 use a plain Continue button (type="button"): moving between steps never runs
       validation, and choices toggle freely. The real submit button only appears on step 4, where
       the browser checks Name / Email on "Send my request". */
    if (total < 2 || !cont || !submit) return;
    root.classList.add('is-wizard');
    if (stepper) stepper.hidden = false;
    if (mstep) mstep.hidden = false;

    function show(n, focus) {
      current = Math.max(1, Math.min(total, n));
      visited = Math.max(visited, current);
      steps.forEach(function (step) {
        step.classList.toggle('is-active', Number(step.dataset.qtStep) === current);
      });
      stepBtns.forEach(function (btn) {
        var i = Number(btn.dataset.qtGoto);
        if (i === current) btn.setAttribute('aria-current', 'step');
        else btn.removeAttribute('aria-current');
        btn.classList.toggle('is-done', i < current || (i < visited && i !== current));
      });
      if (back) back.hidden = current === 1;
      cont.hidden = current === total;
      submit.hidden = current !== total;
      if (mstep) {
        var label = stepBtns[current - 1] ? stepBtns[current - 1].textContent.trim().replace(/^\d+\s*/, '') : '';
        mstep.textContent = (root.dataset.stepOf || '').replace('__C__', current) + (label ? ' · ' + label : '');
      }
      if (focus) {
        var active = steps[current - 1];
        var top = root.getBoundingClientRect().top + window.scrollY - 24;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
        var first = active.querySelector('legend, label');
        if (first) {
          first.setAttribute('tabindex', '-1');
          first.focus({ preventScroll: true });
        }
      }
    }

    stepBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { show(Number(btn.dataset.qtGoto), true); });
    });
    cont.addEventListener('click', function () { show(current + 1, true); });
    if (back) back.addEventListener('click', function () { show(current - 1, true); });

    /* Enter in a step 1–3 field moves on instead of submitting the form early */
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || current === total) return;
      if (e.target.matches('textarea, button, a')) return;
      e.preventDefault();
      show(current + 1, true);
    });

    /* On "Send my request" the browser validates the whole form. If the problem field sits in
       an earlier step (e.g. a malformed crest link), open that step so the message can show. */
    form.addEventListener('invalid', function (e) {
      var step = e.target.closest && e.target.closest('[data-qt-step]');
      if (step && !step.classList.contains('is-active')) show(Number(step.dataset.qtStep), false);
    }, true);

    form.addEventListener('submit', function (e) {
      if (current !== total) {
        e.preventDefault();
        return;
      }
      submit.classList.add('is-loading');
      submit.setAttribute('aria-busy', 'true');
      if (submitLabel && root.dataset.sending) submitLabel.textContent = root.dataset.sending;
    });

    /* Shopify's errors (e.g. invalid email) are only shown on step 4 — open it when present */
    var alertEl = root.querySelector('[data-qt-alert]');
    if (alertEl) visited = total;
    show(alertEl ? total : 1, false);
    if (alertEl) {
      root.scrollIntoView({ block: 'start' });
      alertEl.focus({ preventScroll: true });
    }
  }

  function boot() {
    document.querySelectorAll('[data-n90-quote]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
